
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["yuandianReservation_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M336.5 211h351v53h-351z"}}),_c('path',{attrs:{"d":"M924.9 211H780.5v53h96.1c16.2 0 29.4 13.2 29.4 29.4v515.2c0 16.2-13.2 29.4-29.4 29.4H147.4c-16.2 0-29.4-13.2-29.4-29.4V293.4c0-16.2 13.2-29.4 29.4-29.4h96.1v-53H99.1C80.3 211 65 226.2 65 245.1V857c0 18.8 15.3 34.1 34.1 34.1H925c18.8 0 34.1-15.3 34.1-34.1V245.1c-.1-18.9-15.4-34.1-34.2-34.1z"}}),_c('path',{attrs:{"d":"M290 313c-14.6 0-26.5-11.9-26.5-26.5v-127c0-14.6 11.9-26.5 26.5-26.5s26.5 11.9 26.5 26.5v127c0 14.6-11.9 26.5-26.5 26.5zm444 0c-14.6 0-26.5-11.9-26.5-26.5v-127c0-14.6 11.9-26.5 26.5-26.5s26.5 11.9 26.5 26.5v127c0 14.6-11.9 26.5-26.5 26.5zM265 477.8a87.2 87.2 0 10174.4 0 87.2 87.2 0 10-174.4 0z"}}),_c('path',{attrs:{"d":"M796.8 503h-187c-14.6 0-26.5-11.9-26.5-26.5s11.9-26.5 26.5-26.5h187c14.6 0 26.5 11.9 26.5 26.5S811.4 503 796.8 503zm-40 129.2h-147c-14.6 0-26.5-11.9-26.5-26.5s11.9-26.5 26.5-26.5h147c14.6 0 26.5 11.9 26.5 26.5s-11.9 26.5-26.5 26.5zm2.3 129.3H607.5c-13.3 0-24.2-10.9-24.2-24.2v-4.6c0-13.3 10.9-24.2 24.2-24.2h151.6c13.3 0 24.2 10.9 24.2 24.2v4.6c0 13.3-10.9 24.2-24.2 24.2zm-233.7-4.2c1.1-7.9 1.7-16.1 1.7-24.3 0-96.6-78.3-174.9-174.9-174.9S177.3 636.4 177.3 733c0 8.2.6 16.4 1.7 24.3h346.4z"}})])
          )
        }
      }
    